/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_AllInputs */

const en_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const fr_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const es_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const it_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const nl_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pl_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const fi_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const da_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const sv_portal_scanner_all = /** @type {(inputs: Portal_Scanner_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Portal_Scanner_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_all = /** @type {((inputs?: Portal_Scanner_AllInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_AllInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_all(inputs)
	if (locale === "fr") return fr_portal_scanner_all(inputs)
	if (locale === "es") return es_portal_scanner_all(inputs)
	if (locale === "it") return it_portal_scanner_all(inputs)
	if (locale === "nl") return nl_portal_scanner_all(inputs)
	if (locale === "pl") return pl_portal_scanner_all(inputs)
	if (locale === "fi") return fi_portal_scanner_all(inputs)
	if (locale === "da") return da_portal_scanner_all(inputs)
	if (locale === "sv") return sv_portal_scanner_all(inputs)
	return en_portal_scanner_all(inputs)
});